<template>
  <card body-classes="p-0">
    <!-- Card header -->
    <div class="row" slot="header">
      <div class="col">
        <h5 class="h3 mb-0">Próximas Visitas</h5>
      </div>
    </div>
    <!-- Card body -->
    <ul class="list-group list-group-flush" data-toggle="checklist">
      <li
        class="checklist-entry list-group-item flex-column align-items-start py-4 px-4"
        v-for="schedule in schedule"
        :key="schedule.client"
      >
        <div class="row align-items-center">
          <div class="col ml--2">
            <h5 class="checklist-title mb-0">{{schedule.client.razao_social}}</h5>
            <small>{{schedule.date_start | formatDate('full')}}</small>
          </div>
          <div class="col-auto">
              <router-link
                class="btn btn-sm btn-primary"
                type="button"
                :to="{ name: 'Agendar Visita', params: {client: schedule.client}}"
              >Verificar</router-link>
            </div>
        </div>
      </li>
    </ul>
    <div slot="footer" class="py-4 d-flex justify-content-end">
      <base-pagination
        v-on:input="changePage"
        v-model="paginated_data['current']"
        :total="paginated_data['count']"
        :perPage="paginated_data['per_page']"
      ></base-pagination>
    </div>
  </card>
</template>
<script>
import moment from "moment";
export default {
  name: "general-task-list",
  data() {
    return {
      active: true,
      schedule: [],
      members: [],
      paginated_data: [],
      items: [],
      clients: [],
    };
  },
  mounted(){
    this.getUsers();
    this.$root.$on("filterMember", this.filterMember);
  },
  methods: {
    getUsers(p = null) {
      this.$http.secured
        .get(`/api/v1/users/${this.$currentUser().id}/schedules`, {
          params: {
            page: p,
            per_page: 5,
            status: this.active
          },
        })
        .then((response) => {
          this.paginated_data = response.data;
          this.schedule = this.paginated_data["schedules"];
        })
        .catch((error) => console.log(error, "Something went wrong"));
    },
    changePage(page) {
      this.getUsers(page);
    },
    filterMember(schedule) {
      let url =
        `/api/v1/users/${this.$currentUser().id}/schedules` + schedule.id;
      this.$http.secured.get(url).then((response) => {
        this.schedule = [response.data];
      });
    },
  },
};
</script>
<style></style>
